import React, {
  useCallback,
  createContext,
  useContext,
  useMemo,
  useReducer,
} from 'react';
import PropTypes from 'prop-types';

export const FORM_IDS = Object.freeze({
  PASSWORD: 'password',
  CONFIRM_PASSWORD: 'confirmPassword',
  CURRENT_PASSWORD: 'currentPassword',
});

const PasswordResetContext = createContext();

export function usePasswordResetContext() {
  return useContext(PasswordResetContext);
}

const initialState = {
  errors: {},
  formBag: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_ERRORS':
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.id]: action.payload.message,
        },
      };
    case 'SET_FORM_BAG':
      return {
        ...state,
        formBag: {
          ...state.formBag,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};

export default function PasswordResetProvider({
  children,
  defaultValues: bag,
}) {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    formBag: bag ?? initialState.formBag,
  });

  const setError = useCallback((id, error) => {
    dispatch({
      type: 'SET_ERRORS',
      payload: { id, message: error },
    });
  }, []);

  const setFormValues = useCallback((values) => {
    dispatch({ type: 'SET_FORM_BAG', payload: values });
  }, []);

  const value = useMemo(
    () => ({
      state,
      actions: {
        setError,
        setFormValues,
      },
    }),
    [state]
  );

  return (
    <PasswordResetContext.Provider value={value}>
      {children}
    </PasswordResetContext.Provider>
  );
}

PasswordResetProvider.propTypes = {
  children: PropTypes.node.isRequired,
  defaultValues: PropTypes.object,
};
